<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header">
          <i class="fab fa-delicious"></i> Összesítőpult<small></small>
        </h1>
      </div>
    </div>
    <panel title="Munkafolyamatok" v-if="![8, 9].includes(user.role_id)">
      <Loading v-if="!tasks" title="Munkafolyamatok betöltése"></Loading>
      <NoRecords
        v-if="tasks.length == 0"
        main_icon="fa fa-ticket"
        value="false"
        title="Nincsenek munkafolyamatok"
      ></NoRecords>
      <div class="row" v-if="tasks.length != 0 && tasks != false">
        <div class="col-md-4 col-lg-3" v-for="(task, id) in tasks" :key="id">
          <TaskCard :task="task"></TaskCard>
        </div>
      </div>
    </panel>

    <panel
      v-if="![6, 11, 10].includes(user.role_id)"
      title="Feszültségmentesítések"
    >
      <Loading
        v-if="!isolations"
        title="Feszültségmentesítések betöltése"
      ></Loading>
      <NoRecords
        v-if="
          (user.role_id == 8 &&
            this.isolations.length &&
            this.isolations.filter(
              (isolation) => isolation.is_high_voltage != true
            ).length == 0) ||
          isolations.length == 0
        "
        main_icon="fa fa-bolt"
        value="false"
        title="Nincsenek feszültségmentesítések"
      ></NoRecords>
      <div
        class="row"
        v-if="filtered_isolations.length != 0 && filtered_isolations != false"
      >
        <div
          class="col-md-4 col-lg-3"
          v-for="(isolation, id) in user.role_id == 8
            ? this.isolations.filter(
                (isolation) => isolation.is_high_voltage != true
              )
            : isolations"
          :key="id"
        >
          <IsolationCard :isolation="isolation"></IsolationCard>
        </div>
      </div>
    </panel>

    <panel title="Aláírásra váró engedélyek">
      <Loading v-if="!permit_types" title="Engedélyek"></Loading>
      <NoRecords
        v-if="permit_types.length == 0"
        main_icon="fa fa-list"
        value="false"
        title="Nincsenek aláírásra váró engedélyek"
      ></NoRecords>
      <div class="row" v-else>        
        <div class="col-md-3" v-for="(permit, id) in permit_types" :key="id">
          <SignCard
            top-text="aláírandó"
            :title="permit.permit_type"
            :taskId="permit.task_id"
            :taskName="permit.task_name"
            :date="permit.created_at"
          ></SignCard>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import TaskCard from "../components/TaskCard";
import IsolationCard from "../components/IsolationCard";
import Loading from "../components/Loading";
import NoRecords from "../components/NoRecords";
import Task from "../apis/Task";
import User from "../apis/User";
import Isolation from "../apis/Isolation";
import SignCard from "../components/SignCard";

export default {
  components: {
    TaskCard,
    Loading,
    IsolationCard,
    NoRecords,
    SignCard,
  },
  data() {
    return {
      columns: [
        {
          label: "Munkafolyamat",
          field: "task_name",
        },
        {
          label: "Engedély típusa",
          field: "permit_type",
        },
        {
          label: "Műveletek",
          field: "actions",
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      tasks: false,
      isolations: false,
      operators: false,
      permits: false,
      permit_types: false,
      back_url: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    filtered_isolations() {
      if (this.isolations.length) {
        if (this.user.role_id == 8) {
          return this.isolations.filter(
            (isolation) => isolation.is_high_voltage != true
          );
        }
        return this.isolations;
      }
      return [];
    },
  },
  mounted() {
    this.back_url = process.env.VUE_APP_BACK_URL;

    this.$root.$on("role-id-updated", () => {
      Task.index().then((response) => {
        this.tasks = response.data;
      });
      Isolation.index().then((response) => {
        this.isolations = response.data;
      });

      User.getPermitTypes().then((response) => {
        this.permit_types = response.data;
      });
    });
  },
  created() {
    window.Echo.channel("tasks")
      .listen("TaskCreated", (e) => {
        if (![7, 8, 9].includes(this.user.role_id)) {
          this.tasks.unshift(e);
        }
      })
      .listen("TaskUpdated", (e) => {
        if (![8, 9].includes(this.user.role_id)) {
          this.tasks[this.tasks.map((t) => t.id).indexOf(e.id)] = JSON.parse(
            JSON.stringify(e)
          );
          this.$forceUpdate(
            this.tasks[this.tasks.map((t) => t.id).indexOf(e.id)]
          );
          this.$forceUpdate(this.tasks);
        }
      });

    window.Echo.channel("isolations")
      .listen("IsolationCreated", (e) => {
        this.isolations.unshift(e);
      })
      .listen("IsolationUpdated", (e) => {
        let existingindex = this.isolations.findIndex((i) => i.id == e.id);
        if (
          [8, 9].includes(this.user.role_id) &&
          existingindex != -1 &&
          e.user_id != this.user.id
        ) {
          this.isolations.splice(existingindex, 1);
        } else {
          this.isolations[this.isolations.findIndex((i) => i.id == e.id)] = e;
          this.$forceUpdate(this.isolations);
        }
      });

    window.Echo.private("App.User." + this.user.id)
      .listen("IsolationAssigned", (e) => {
        let existingindex = this.isolations.findIndex((i) => i.id == e.id);
        if (existingindex != -1) {
          this.isolations[existingindex] = e;
        } else {
          this.isolations.unshift(e);
        }
      })
      .listen("TaskAssigned", (e) => {
        this.tasks.unshift(e);
      });

    User.getRole(7).then((response) => {
      this.operators = response.data;
    });

    if ([8, 9].indexOf(this.user.role_id) == -1) {
      Task.index().then((response) => {
        this.tasks = response.data;
      });
    }

    User.getPermitTypes().then((response) => {
      this.permit_types = response.data;
    });

    Isolation.index().then((response) => {
      this.isolations = response.data;
    });
  },
  beforeDestroy() {
    /*	window.Echo.private('App.User.' + this.user.id).unsubscribe();
			window.Echo.channel('tasks').unsubscribe();
			window.Echo.channel('isolations').unsubscribe();*/
    window.Echo.channel("tasks").stopListening("TaskUpdated");
    window.Echo.channel("tasks").stopListening("TaskCreated");
  },
};
</script>
